var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2666(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2666",
    "data-name": "Group 2666",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.291,
    height: 60.951,
    viewBox: "0 0 65.291 60.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4566",
    "data-name": "Path 4566",
    d: "M-739.272,51.066q-12.858,0-25.717,0a6.97,6.97,0,0,1-6.946-7.185,7.41,7.41,0,0,1,1.011-3.346q12.042-22.092,24.07-44.192c.433-.8.872-1.587,1.305-2.382a6.788,6.788,0,0,1,6.266-3.838,6.772,6.772,0,0,1,6.271,3.828q7.36,13.505,14.714,27.013,5.376,9.869,10.746,19.742a6.886,6.886,0,0,1-4.392,10.148,8.244,8.244,0,0,1-1.951.208Q-726.584,51.078-739.272,51.066Zm-.095-4.344q12.761,0,25.521,0A2.545,2.545,0,0,0-711.5,42.8q-12.657-23.39-25.322-46.776a2.661,2.661,0,0,0-2.418-1.585,2.653,2.653,0,0,0-2.5,1.57q-12.748,23.416-25.5,46.831a2.86,2.86,0,0,0-.357,1.08,2.544,2.544,0,0,0,2.7,2.795Q-752.128,46.727-739.367,46.722Z",
    transform: "translate(771.939 9.882)",
    fill: "#d10a11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4567",
    "data-name": "Path 4567",
    d: "M-543.618,128.934q0,4.18,0,8.361a2.217,2.217,0,0,1-2.16,2.449,2.212,2.212,0,0,1-2.182-2.427q0-8.463,0-16.925a2.2,2.2,0,0,1,2.192-2.412,2.206,2.206,0,0,1,2.149,2.391Q-543.613,124.652-543.618,128.934Z",
    transform: "translate(578.449 -100.575)",
    fill: "#d10a11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4568",
    "data-name": "Path 4568",
    d: "M-555.253,314.328a4.377,4.377,0,0,1-4.386,4.347,4.377,4.377,0,0,1-4.312-4.352,4.373,4.373,0,0,1,4.385-4.346A4.373,4.373,0,0,1-555.253,314.328Z",
    transform: "translate(592.261 -266.439)",
    fill: "#d10a11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2666);
export default __webpack_public_path__ + "static/media/Group 2666.d2dc537c53cf0b49e070a942c83850c4.svg";
export { ForwardRef as ReactComponent };